import { MerchantTable } from "../../../../src/components/MerchantTable";
import { Link } from 'gatsby';
import * as React from 'react';
export default {
  MerchantTable,
  Link,
  React
};